export const createSummaryTrans = (savingsClass, prevTranObj, prevTranYear, totalTranAmt, 
       totalShareQuantity, createBalanceFwd) => {

    let tranObj = {};
    let newTranArr = [];
    let tranNbr = prevTranObj.tranNbr + 1;
    let tranType = "End of Year Account Balance";
    let shareQuantity = 0;
    if (!isNaN(totalShareQuantity)){
        shareQuantity = (+totalShareQuantity).toFixed(4);
    }
    tranObj = {savingsType: prevTranObj.savingsType, 
            tranYear: prevTranYear,
            tranType: tranType,
            tranAmt: totalTranAmt,
            tranSort: prevTranObj.tranSort,
            typeSortValue: prevTranObj.typeSortValue,
            tranNbr: tranNbr,
            className: "font-weight-bold"};
    if (savingsClass === "retirement"){
        tranObj = {...tranObj, sharePrice: prevTranObj.sharePrice, shareQuantity: shareQuantity}
    }
    newTranArr.push(tranObj);
    if (createBalanceFwd === true && prevTranYear !== "all"){
        tranNbr += 1;
        let  tranYear = (+prevTranYear + 1).toString();
        tranObj = {savingsType: prevTranObj.savingsType,
            tranYear: tranYear,
            tranType: "Balance Forward",
            tranAmt: totalTranAmt,
            tranSort: prevTranObj.tranSort,
            typeSortValue: prevTranObj.typeSortValue,
            tranNbr: tranNbr,
            className: "font-weight-bold"
        }
        if (savingsClass === "retirement"){
            tranObj = {...tranObj, sharePrice: prevTranObj.sharePrice, shareQuantity: shareQuantity}
        }
        newTranArr.push(tranObj)
    }
    return newTranArr;
}
export default createSummaryTrans